import { render } from "./InfoPickUp.vue?vue&type=template&id=c429eaac"
import script from "./InfoPickUp.vue?vue&type=script&lang=js"
export * from "./InfoPickUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__